import React, { useState } from 'react';

import { FamilyAddress } from 'common/api/crm/family/address/models/FamilyAddress';
import { LoadingOverlay } from 'components/loading-overlay/LoadingOverlay';
import { noop } from 'common/utils';

export interface PaymentOptionsContextProps {
    addresses: FamilyAddress[];
    selectedAddress: string;
    setSelectedAddress: (_: string) => void;
    createMode: boolean;
    setCreateMode: (_: boolean) => void;
    refreshAddresses: () => void;
    loader: React.RefObject<LoadingOverlay> | null;
    reloadAchInfo: () => Promise<void>;

    // debug props
    showBankAccountMode?: boolean;
    debugMode?: boolean;
}

export const PaymentOptionsContext = React.createContext<PaymentOptionsContextProps>({
    addresses: [] as FamilyAddress[],
    selectedAddress: '',
    setSelectedAddress: noop,
    createMode: false,
    setCreateMode: noop,
    refreshAddresses: noop,
    loader: null,
    reloadAchInfo: () => Promise.resolve(),

    // debug props
    showBankAccountMode: true,
    debugMode: true,
});

export const PaymentOptionsView = ({
    addresses,
    children,
    loader,
    refreshAddresses,
    reloadAchInfo,
}: React.PropsWithChildren<
    Pick<PaymentOptionsContextProps, 'addresses' | 'reloadAchInfo' | 'refreshAddresses' | 'loader'>
>) => {
    const [selectedAddress, setSelectedAddress] = useState<string>('');
    const [createMode, setCreateMode] = useState<boolean>(false);

    const context = {
        addresses,
        showBankAccountMode: true,
        debugMode: true,
        selectedAddress,
        setSelectedAddress,
        createMode,
        setCreateMode,
        refreshAddresses,
        loader,
        reloadAchInfo,
    };
    return (
        <PaymentOptionsContext.Provider value={context}>{children}</PaymentOptionsContext.Provider>
    );
};
